import { useFormik } from "formik";
import moment from "moment";
import React, { useContext, useEffect, useState } from "react";
import { FiPlusSquare } from "react-icons/fi";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useFilters, useGlobalFilter, useSortBy, useTable } from "react-table";
import { toast } from "react-toastify";
import OrderImg from "../../assets/orders/order.svg";
import Button from "../../components/buttton/button";
import { useDialogContext } from "../../components/dialogs/Dialog";
import FormInput from "../../components/form/FormInput";
import FormTextarea from "../../components/form/FormTextarea";
import PageHeader from "../../components/table/pageHeader/PageHeader";
import useList from "../../controller/list-controller";
import useOrder from "../../controller/order-controller";
import { calculateGST, numberFormat } from "../../utils/helper";
import "./order-create.scss";
import { validationSchema } from "./validationSchema";
import FormSelect from "../../components/form/FormSelect";
import { useBottomSheetContext } from "../../components/dialogs/bottomsheet";
import { ProductListContext } from "../../context/productListContext";
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
  AccordionItemState,
} from "react-accessible-accordion";

function OrderCreate() {
  const {
    succMsg,
    errMsg,
    isLoading: isLoading2,
    createdOrderData,
    createOrder,
  } = useOrder();
  const { getConstants, allConst } = useList();
  const productContData = useContext(ProductListContext);
  const { setAccountId } = productContData;
  const { dispatch } = useDialogContext();
  const { dispatch: dis } = useBottomSheetContext();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const paramsAccId = searchParams?.get("accId");
  const [data, setData] = useState([]);
  const [gTotal, setGTotal] = useState(0);
  const [openAcc, setOpenAcc] = useState(["0", "1", "2", "3", "4"]);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 959);

  const formik = useFormik({
    initialValues: {
      accountId: paramsAccId || "",
      buyerPODate: moment().format("YYYY-MM-DD"),
      buyerPONumber: "",
      specialDiscount: "",
      description: "",
      orderLineItem: [],
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: (values) => {
      const totalQty = data.reduce(
        (acc, curr) => acc + Number(curr.quantity),
        0
      );

      const values1 = {
        OrderDetails: {
          account: {
            id: values.accountId,
            name: values.accountName,
          },
          ownerId: null,
          status: "Order Placed",
          currencyCode: "INR",
          type: "Dealer",
          sendToBusyStatus: "Pending",
          orderStartDate: moment().format("YYYY-MM-DD"),
          buyerPODate: values.buyerPODate,
          buyerPONumber: values.buyerPONumber,
          description: values.description,
          billingAddress: {
            street: values.billingStreet,
            city: values.billingCity,
            state: values.billingState,
            postalCode: values.billingPostalCode,
            country: values.billingCountry,
          },
          shippingAddress: {
            street: values.shippingStreet,
            city: values.shippingCity,
            state: values.shippingState,
            postalCode: values.shippingPostalCode,
            country: values.shippingCountry,
          },
          isPortalOrder: "Yes",
          specialDiscountId: null,
          specialDiscount: values.specialDiscount,
          totalMOQ: totalQty,
          // grandTotal: numberFormat(gTotal),
          orderLines: data
            ?.filter((orderI, index) => {
              return orderI?.productId;
            })
            ?.map((data) => {
              const { tempQuantity, ...orderData } = data;
              return {
                ...orderData,
                product: {
                  id: orderData.productId,
                  name: orderData.productName,
                },
                currencyCode: orderData.currency,
                priceAfterDiscount: orderData.discountPrice,
                offerAndDiscountId: null,
              };
            }),
        },
      };

      createOrder(values1, false);
    },
  });
  const handleChangeQuantity = (index, value) => {
    const temp = [...data];
    let q = value || temp[index].quantity;

    if (!q || q == 0) {
      const totPri = temp[index]?.["unitPriced"] * 1;
      const gst = calculateGST(totPri * temp[index].gst);
      temp[index] = {
        ...temp[index],
        quantity: Number(1),
        tempQuantity: Number(1),
        totalPrice: Math.round((totPri + gst) * 1000) / 1000,
      };
      setData(temp);
    } else {
      temp[index].quantity = q;
      temp[index].tempQuantity = q;
      const totPri = temp[index]?.["unitPriced"] * (q || 0);
      const gst = calculateGST(totPri * temp[index].gst);
      temp[index].totalPrice = Math.round((totPri + gst) * 1000) / 1000;
      setData(temp);
    }
  };
  const handleAddName = (item = {}, index, tempData) => {
    const additionalDiscount = 0;
    const temp = [...tempData];
    const t1 = item.unitPrice;
    const t3 = t1 * (item?.discount / 100 + additionalDiscount / 100);
    const unitPriced = t1 - t3;
    const totPri = unitPriced * 1;
    const gst = calculateGST(totPri * item.gst);
    temp[index] = {
      ...temp[index],
      ...item,
      unitPrice: t1,
      unitPriced: unitPriced,
      quantity: 1,
      tempQuantity: 1,
      discountPrice: Math.round(unitPriced * 1000) / 1000,
      totalPrice: Math.round((totPri + gst) * 1000) / 1000,
      additionalDiscount: additionalDiscount,
    };
    setData(temp);
  };
  const columns = React.useMemo(
    () => [
      {
        Header: "",
        accessor: "id",
        Cell: ({ value: initialValue, row: { index }, column: { id } }) => (
          <p>{index + 1}</p>
        ),
      },
      {
        Header: "Product Name",
        accessor: "productName",
        Cell: ({
          value: initialValue,
          row: { index },
          column: { id },
          data,
        }) => {
          return (
            <>
              <div className="md:block hidden">
                <FormInput
                  dom={{
                    type: "text",
                    name: "productName",
                    value: data[index].productName,
                    className: "p-2",
                    onClick: () => {
                      dispatch({
                        type: "openDialog",
                        payload: {
                          data: {
                            handleAddName: handleAddName,
                            pdata: data,
                            footer: true,
                            cancelBtn: true,
                            index: index,
                            isSearch: true,
                            title: "Product Name",
                            buttonText: {
                              submit: "Save",
                            },
                            className: "!p-0",
                          },
                          path: `orders/ProductList`,
                        },
                      });
                    },
                  }}
                  required={true}
                  fullwidth={true}
                />
              </div>
              <div
                className="md:hidden block"
                onClick={() => {
                  dis({
                    type: "openBottomSheet",
                    payload: {
                      data: {
                        modalType: "list",
                        handleAddName: handleAddName,
                        pdata: data,
                        index: index,
                        footer: true,
                        cancelBtn: true,
                        isSearch: true,
                        title: "Product Name",
                        buttonText: {
                          submit: "Save",
                        },
                        className: "!p-0",
                      },
                      path: `orders/ProductList`,
                    },
                  });
                }}
              >
                <FormInput
                  dom={{
                    type: "text",
                    name: "productName",
                    value: data[index].productName,
                    className: "p-2",
                    readOnly: true,
                  }}
                  required={true}
                  fullwidth={true}
                />
              </div>
            </>
          );
        },
      },
      { Header: "Product Code", accessor: "productCode" },
      { Header: "Unit Price", accessor: "unitPrice" },
      {
        Header: "Product Quantity",
        accessor: "quantity",
        Cell: ({
          value: initialValue,
          row: { index },
          column: { id },
          data,
        }) => {
          return (
            <div>
              <FormInput
                dom={{
                  type: "number",
                  name: "quantity",
                  className: "p-2",
                  disabled: !data[index].productName,
                  value: data[index].tempQuantity,
                  onFocus: (e) => {
                    const temp = [...data];
                    temp[index].tempQuantity = "";
                    setData(temp);
                  },
                  onChange: (e) => {
                    let q = e.target.value;
                    const temp = [...data];
                    temp[index].quantity = q;
                    temp[index].tempQuantity = q;
                    const totPri = temp[index]?.["unitPriced"] * (q || 0);
                    const gst = calculateGST(totPri * temp[index].gst);
                    temp[index].totalPrice =
                      Math.round((totPri + gst) * 1000) / 1000;
                    setData(temp);
                  },
                  onBlur: (e) => {
                    const temp = [...data];
                    let q = e.target.value || temp[index].quantity;

                    if (!q || q == 0) {
                      const totPri = temp[index]?.["unitPriced"] * 1;
                      const gst = calculateGST(totPri * temp[index].gst);
                      temp[index] = {
                        ...temp[index],
                        quantity: Number(1),
                        tempQuantity: Number(1),
                        totalPrice: Math.round((totPri + gst) * 1000) / 1000,
                      };
                      setData(temp);
                    } else {
                      temp[index].tempQuantity = temp[index].quantity;
                      setData(temp);
                    }
                  },
                }}
                required={true}
                fullwidth={true}
              />
            </div>
          );
        },
      },
      {
        Header: "Discount",
        accessor: "discount",
        Cell: (row) => {
          return `${row?.value}%`;
        },
      },
      // {
      //   Header: "Additional Discount",
      //   accessor: "additionalDiscount",
      //   Cell: (row) => {
      //     return `${
      //       row?.row?.original?.additionalDiscount
      //         ? row?.row?.original?.additionalDiscount?.toFixed(2)
      //         : 0.0
      //     }%`;
      //   },
      // },
      {
        Header: "Price After Discount",
        accessor: "discountPrice",
      },
      {
        Header: "GST",
        accessor: "gst",
        Cell: (row) => {
          return `${row?.value}%`;
        },
      },
      {
        Header: "Total Price",
        accessor: "totalPrice",
        Cell: (row) => {
          return `${numberFormat(row?.value)}`;
        },
      },
      {
        Header: "",
        accessor: "action",
        Cell: ({
          value: initialValue,
          row: { index },
          column: { id },
          data,
        }) => {
          return (
            <div className="flex flex-row justify-end">
              <div
                className="p-2"
                style={{
                  width: "fit-content",
                  color: "#A31400",
                  fontSize: 18,
                }}
                onClick={() => {
                  const tempArr = [...data];
                  tempArr.splice(index, 1);
                  setData(tempArr);
                }}
              >
                <RiDeleteBin6Line />
              </div>
            </div>
          );
        },
      },
    ],
    [allConst]
  );

  useEffect(() => {
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    if (allConst) {
      formik.setFieldValue("accountName", allConst?.accountName);
      formik.setFieldValue(
        "isBuyerPONumberMandatory",
        allConst?.isBuyerPONumberMandatory
      );
      formik.setFieldValue("billingStreet", allConst?.billingStreet);
      formik.setFieldValue("billingCity", allConst?.billingCity);
      formik.setFieldValue("billingState", allConst?.billingState);
      formik.setFieldValue("billingPostalCode", allConst?.billingPostalCode);
      formik.setFieldValue("billingCountry", allConst?.billingCountry);
      formik.setFieldValue("shippingStreet", allConst?.shippingStreet);
      formik.setFieldValue("shippingCity", allConst?.shippingCity);
      formik.setFieldValue("shippingState", allConst?.shippingState);
      formik.setFieldValue("shippingPostalCode", allConst?.shippingPostalCode);
      formik.setFieldValue("shippingCountry", allConst?.shippingCountry);
    }
  }, [allConst]);

  useEffect(() => {
    if (data.length > 0) {
      const sum = data.reduce(
        (prev, current) => parseFloat(prev) + parseFloat(current.totalPrice),
        0
      );
      setGTotal(Math.round(sum * 1000) / 1000);
    } else {
      setGTotal(0);
    }
  }, [data]);

  useEffect(() => {
    if (Object.keys(createdOrderData).length > 0) {
      if (window.innerWidth < 960) {
        dis({
          type: "openBottomSheet",
          payload: {
            data: {
              createOrder: createOrder,
              values: createdOrderData,
              gTotal: gTotal,
              footer: false,
              cancelBtn: true,
              title: "Order Preview",
              onSubmit: true,
              className: "pb-0 !p-0 md:w-[80vw]",
            },
            path: `OrderPreview`,
          },
        });
      } else {
        dispatch({
          type: "openDialog",
          payload: {
            data: {
              createOrder: createOrder,
              values: createdOrderData,
              gTotal: gTotal,
              footer: false,
              cancelBtn: true,
              title: "Order Preview",
              onSubmit: true,
              className: "pb-0 !p-0",
            },
            path: `OrderPreview`,
          },
        });
      }
    }
  }, [createdOrderData]);

  useEffect(() => {
    if (paramsAccId) {
      setAccountId(paramsAccId);
      formik.setFieldValue("accountId", paramsAccId);
    }
  }, [paramsAccId]);

  useEffect(() => {
    if (formik.values.accountId) {
      setData([]);
      setGTotal(0);
      formik.setFieldValue("specialDiscount", "");
      getConstants({
        objectName: "Order",
        accountId: formik.values.accountId,
      });
    }
  }, [formik.values.accountId]);

  useEffect(() => {
    if (succMsg) {
      toast.success(succMsg);
      formik.resetForm();
      navigate("/orders");
    }
  }, [succMsg]);

  useEffect(() => {
    if (errMsg) {
      toast.error(errMsg);
    }
  }, [errMsg]);

  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, rows } =
    useTable(
      {
        columns,
        data,
      },
      useFilters,
      useGlobalFilter,
      useSortBy
    );

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 959);
  };

  return (
    <div className="flex flex-col h-full w-full md:pb-0 pb-8">
      <PageHeader
        img={OrderImg}
        text="Order"
        subTitle="Place Order"
        isBackBtn={true}
        onBackClick={() => navigate("/orders")}
      />
      <div
        className="order-create-container md:p-4 md:rounded-lg h-full w-full overflow-auto"
        id="scroll-div"
      >
        <form
          id="createOrderForm"
          onSubmit={formik.handleSubmit}
          className="w-full"
        >
          <div className="title py-3.5 px-4 md:rounded-lg font-semibold text-base">
            Information
          </div>
          <div className="py-6 md:px-0 px-4">
            <div className="grid md:grid-cols-3 md:mb-5 gap-x-7 md:gap-y-0 gap-y-2">
              <div className="md:block hidden">
                <FormInput
                  label="Account Name"
                  dom={{
                    type: "text",
                    name: "accountName",
                    className: "pr-9",
                    disabled: paramsAccId,
                    value: formik?.values?.accountName,
                    onClick: () => {
                      dispatch({
                        type: "openDialog",
                        payload: {
                          data: {
                            handleAddName: (values) => {
                              formik?.setFieldValue(
                                "accountId",
                                values?.accountId
                              );
                              formik?.setFieldValue(
                                "accountName",
                                values?.accountName
                              );
                            },
                            footer: true,
                            cancelBtn: true,
                            isSearch: true,
                            title: "Accounts",
                            buttonText: {
                              submit: "Save",
                            },
                            className: "!p-0",
                          },
                          path: `orders/AccountsList`,
                        },
                      });
                    },
                  }}
                  required={true}
                  fullwidth={true}
                  error={
                    formik.touched.accountName &&
                    Boolean(formik.errors.accountName)
                  }
                  errorMessage={
                    formik.touched.accountName && formik.errors.accountName
                  }
                />
              </div>
              <div
                className="md:hidden block"
                onClick={() => {
                  dis({
                    type: "openBottomSheet",
                    payload: {
                      data: {
                        modalType: "list",
                        handleAddName: (values) => {
                          formik?.setFieldValue("accountId", values?.accountId);
                          formik?.setFieldValue(
                            "accountName",
                            values?.accountName
                          );
                        },
                        footer: true,
                        cancelBtn: true,
                        isSearch: true,
                        title: "Accounts",
                        buttonText: {
                          submit: "Save",
                        },
                        className: "!p-0",
                      },
                      path: `orders/AccountsList`,
                    },
                  });
                }}
              >
                <FormInput
                  label="Account Name"
                  dom={{
                    type: "text",
                    name: "accountName",
                    readOnly: true,
                    className: "pr-9",
                    disabled: paramsAccId,
                    value: formik?.values?.accountName,
                  }}
                  required={true}
                  fullwidth={true}
                  error={
                    formik.touched.accountName &&
                    Boolean(formik.errors.accountName)
                  }
                  errorMessage={
                    formik.touched.accountName && formik.errors.accountName
                  }
                />
              </div>
              <div className="">
                <FormInput
                  label="Buyer PO Date"
                  dom={{
                    name: "buyerPODate",
                    type: "date",
                    readOnly: true,
                    disabled: true,
                    className: "p-2.5 text-start",
                    value: formik?.values?.buyerPODate,
                    onChange: (e) => {
                      formik.setFieldValue("buyerPODate", e.target.value, true);
                    },
                  }}
                  required={true}
                  fullwidth={true}
                  error={
                    formik.touched.buyerPODate &&
                    Boolean(formik.errors.buyerPODate)
                  }
                  errorMessage={
                    formik.touched.buyerPODate && formik.errors.buyerPODate
                  }
                />
              </div>

              <div>
                <FormInput
                  label="Buyer PO Number"
                  dom={{
                    name: "buyerPONumber",
                    type: "text",
                    value: formik?.values?.buyerPONumber,
                    onChange: (e) =>
                      formik.setFieldValue(
                        "buyerPONumber",
                        e.target.value,
                        true
                      ),
                  }}
                  required={
                    formik?.values?.isBuyerPONumberMandatory ? true : false
                  }
                  fullwidth={true}
                  error={
                    formik.touched.buyerPONumber &&
                    Boolean(formik.errors.buyerPONumber)
                  }
                  errorMessage={
                    formik.touched.buyerPONumber && formik.errors.buyerPONumber
                  }
                />
              </div>

              <div className="md:mt-3">
                <FormSelect
                  label="Special Discount"
                  className={"py-0 search-select"}
                  options={allConst?.specialDiscountOptions || []}
                  isClearable={false}
                  isSearchable={false}
                  isDisabled={!formik.values.accountId}
                  name="specialDiscount"
                  fullwidth={true}
                  onChange={(value) => {
                    formik.setFieldValue("specialDiscount", value?.value);
                  }}
                  preFixClass="right-4"
                  value={{
                    label: formik?.values?.specialDiscount,
                    value: formik?.values?.specialDiscount,
                  }}
                  error={!formik.values.accountId}
                  errorMessage={
                    formik.values.accountId
                      ? formik.touched.specialDiscount
                        ? formik.errors.specialDiscount
                        : ""
                      : "Please select account name to select discount."
                  }
                />
              </div>
            </div>
          </div>

          <div className="title py-3.5 px-4 md:rounded-lg font-semibold text-base mb-4">
            Product Details
          </div>
          {!isMobile ? (
            <div className="md:block hidden w-full overflow-auto">
              <table {...getTableProps()} className="w-full">
                <thead>
                  {headerGroups.map((headerGroup, i) => (
                    <tr {...headerGroup.getHeaderGroupProps()} key={i}>
                      {headerGroup.headers.map((column, i) => (
                        <th
                          {...column.getHeaderProps(
                            column?.id !== "action" &&
                              column.getSortByToggleProps()
                          )}
                          className={`md:text-lg text-base md:min-w-fit min-w-[180px] p-3 font-bold  ${
                            column.isSorted
                              ? "flex flex-row justify-between items-center"
                              : ""
                          } p-3.5	${
                            i === 0 ? "md:rounded-tl-lg min-w-[80px]" : ""
                          } ${
                            i === headerGroup.headers.length - 1
                              ? "md:rounded-tr-lg"
                              : ""
                          }`}
                        >
                          {column.render("Header")}
                          <span>
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <div className="accIconClose inline-block mr-3 rotate-45 ml-2" />
                              ) : (
                                <div className="accIconOpen inline-block mr-3 ml-2" />
                              )
                            ) : (
                              ""
                            )}
                          </span>
                        </th>
                      ))}
                    </tr>
                  ))}
                </thead>
                <tbody {...getTableBodyProps()}>
                  {rows.map((row, i) => {
                    prepareRow(row);
                    return (
                      <tr
                        {...row.getRowProps()}
                        key={i}
                        className="cursor-pointer"
                      >
                        {row.cells.map((cell) => {
                          return (
                            <td
                              {...cell.getCellProps()}
                              className="p-3 md:text-base text-sm"
                            >
                              {cell.render("Cell")}
                            </td>
                          );
                        })}
                      </tr>
                    );
                  })}

                  {rows?.length < 1 ? (
                    <tr>
                      <td colSpan={2}>
                        <p className="p-3 font-medium text-sm no-table-record">
                          No Record Found
                        </p>
                      </td>
                    </tr>
                  ) : null}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="md:hidden block accordianWrapper">
              <Accordion
                allowMultipleExpanded={true}
                allowZeroExpanded={true}
                preExpanded={["0", "1", "2", "3", "4"]}
                onChange={(item) => setOpenAcc(item)}
              >
                <div className="accButton title mb-3 py-4 ps-[80px] grid grid-cols-2">
                  <label className="block me-[40px]">Product Name</label>
                  <label className="block">Product Quantity</label>
                </div>
                {data.length > 0
                  ? data.map((item, index) => {
                      return (
                        <AccordionItem uuid={index} className="accItem">
                          <AccordionItemHeading>
                            <AccordionItemButton
                              className={`bg-white-100 accButton py-4 px-4 flex flex-row justify-between items-center ${
                                openAcc.includes(index)
                                  ? "md:rounded-t-lg"
                                  : "md:rounded-lg"
                              }`}
                            >
                              <div className="w-full flex flex-row font-semibold md:text-[22px] text-base accTitle">
                                <div>
                                  <button
                                    type="button"
                                    className="btn btn-primary-outlined me-1 min-w-[40px] h-full text-xl p-0 !border-0"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      const tempArr = [...data];
                                      tempArr.splice(index, 1);
                                      setData(tempArr);
                                    }}
                                  >
                                    <RiDeleteBin6Line />
                                  </button>
                                </div>
                                <div className="grow">
                                  <div className="md:block hidden">
                                    <FormInput
                                      dom={{
                                        type: "text",
                                        name: "productName",
                                        value: data[index].productName,
                                        className: "p-2",
                                        onClick: () => {
                                          dispatch({
                                            type: "openDialog",
                                            payload: {
                                              data: {
                                                handleAddName: handleAddName,
                                                pdata: data,
                                                index: index,
                                                footer: true,
                                                cancelBtn: true,
                                                isSearch: true,
                                                title: "Product Name",
                                                buttonText: {
                                                  submit: "Save",
                                                },
                                                className: "!p-0",
                                              },
                                              path: `orders/ProductList`,
                                            },
                                          });
                                        },
                                      }}
                                      required={true}
                                      fullwidth={true}
                                    />
                                  </div>
                                  <div
                                    className="md:hidden block"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      dis({
                                        type: "openBottomSheet",
                                        payload: {
                                          data: {
                                            modalType: "list",
                                            handleAddName: handleAddName,
                                            pdata: data,
                                            index: index,
                                            footer: true,
                                            cancelBtn: true,
                                            isSearch: true,
                                            title: "Product Name",
                                            buttonText: {
                                              submit: "Save",
                                            },
                                            className: "!p-0",
                                          },
                                          path: `orders/ProductList`,
                                        },
                                      });
                                    }}
                                  >
                                    <FormInput
                                      dom={{
                                        type: "text",
                                        name: "productName",
                                        value: data[index].productName,
                                        className: "p-2",
                                        readOnly: true,
                                      }}
                                      required={true}
                                      fullwidth={true}
                                    />
                                  </div>
                                </div>
                                <div className="flex items-center">
                                  <button
                                    type="button"
                                    disabled={!data[index].productName}
                                    className="bg-primary text-white-100 mx-2 min-w-[20px] w-[20px] min-h-[20px] h-[20px] rounded-full text-xl p- flex justify-center items-center"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleChangeQuantity(
                                        index,
                                        parseInt(data[index].tempQuantity) + 1
                                      );
                                    }}
                                  >
                                    +
                                  </button>
                                  <div>
                                    <FormInput
                                      dom={{
                                        type: "number",
                                        name: "quantity",
                                        className: "p-2",
                                        disabled: !data[index].productName,
                                        value: data[index].tempQuantity,
                                        onClick: (e) => e.stopPropagation(),
                                        onFocus: (e) => {
                                          const temp = [...data];
                                          // temp[index].tempQuantity = "";
                                          setData(temp);
                                        },
                                        onChange: (e) => {
                                          let q = e.target.value;
                                          const temp = [...data];
                                          temp[index].quantity = q;
                                          temp[index].tempQuantity = q;
                                          const totPri =
                                            temp[index]?.["unitPriced"] *
                                            (q || 0);
                                          const gst = calculateGST(
                                            totPri * temp[index].gst
                                          );
                                          temp[index].totalPrice =
                                            Math.round((totPri + gst) * 1000) /
                                            1000;
                                          setData(temp);
                                        },
                                        onBlur: (e) => {
                                          const temp = [...data];
                                          let q =
                                            e.target.value ||
                                            temp[index].quantity;

                                          if (!q || q == 0) {
                                            const totPri =
                                              temp[index]?.["unitPriced"] * 1;
                                            const gst = calculateGST(
                                              totPri * temp[index].gst
                                            );
                                            temp[index] = {
                                              ...temp[index],
                                              quantity: Number(1),
                                              tempQuantity: Number(1),
                                              totalPrice:
                                                Math.round(
                                                  (totPri + gst) * 1000
                                                ) / 1000,
                                            };
                                            setData(temp);
                                          } else {
                                            temp[index].tempQuantity =
                                              temp[index].quantity;
                                            setData(temp);
                                          }
                                        },
                                      }}
                                      required={true}
                                      fullwidth={true}
                                    />
                                  </div>
                                  <button
                                    type="button"
                                    disabled={!data[index].productName}
                                    className="bg-primary text-white-100 ms-2 min-w-[20px] w-[20px] min-h-[20px] h-[20px] rounded-full text-xl p- flex justify-center items-center"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      handleChangeQuantity(
                                        index,
                                        parseInt(data[index].tempQuantity) - 1
                                      );
                                    }}
                                  >
                                    -
                                  </button>
                                </div>
                              </div>
                              <AccordionItemState>
                                {({ expanded }) =>
                                  expanded ? (
                                    <div className="min-w-[40px] h-full flex justify-center items-center">
                                      <div className="accIconOpen inline-block" />
                                    </div>
                                  ) : (
                                    <div className="min-w-[40px] h-full flex justify-center items-center">
                                      <div className="accIconClose inline-block rotate-45" />
                                    </div>
                                  )
                                }
                              </AccordionItemState>
                            </AccordionItemButton>
                          </AccordionItemHeading>
                          <AccordionItemPanel>
                            <div className="bg-white-100 accPanel grid md:rounded-b-lg md:py-6 px-4">
                              <div className="grid md:grid-cols-2 md:mb-4">
                                <div className="grid grid-cols-2 fieldWrapper pb-2 md:mr-10 md:mb-0 mb-4">
                                  <div className="fieldName">Product Name</div>
                                  <div className="fieldDetails">
                                    {item?.productName}
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 fieldWrapper pb-2 md:mb-0 mb-4">
                                  <div className="fieldName">Product Code</div>
                                  <div className="fieldDetails">
                                    {item?.productCode}
                                  </div>
                                </div>
                              </div>
                              <div className="grid md:grid-cols-2 md:mb-4">
                                <div className=" grid grid-cols-2 fieldWrapper pb-2 md:mr-10 md:mb-0 mb-4">
                                  <div className="fieldName">Unit Price</div>
                                  <div className="fieldDetails">
                                    {item?.unitPrice ? item?.unitPrice : "NA"}
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 fieldWrapper pb-2 md:mb-0 mb-4">
                                  <div className="fieldName">
                                    Product Quantity
                                  </div>
                                  <div className="fieldDetails">
                                    {item?.quantity || 1}
                                  </div>
                                </div>
                              </div>
                              <div className="grid md:grid-cols-2 md:mb-4">
                                <div className=" grid grid-cols-2 fieldWrapper pb-2 md:mr-10 md:mb-0 mb-4">
                                  <div className="fieldName">Discount</div>
                                  <div className="fieldDetails">
                                    {item?.discount
                                      ? item?.discount + "%"
                                      : "NA"}
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 fieldWrapper pb-2 md:mb-0 mb-4">
                                  <div className="fieldName">
                                    Price After Discount
                                  </div>
                                  <div className="fieldDetails">
                                    {item?.priceAfterDiscount ? (
                                      item?.priceAfterDiscount
                                    ) : (
                                      <>NA</>
                                    )}
                                  </div>
                                </div>
                              </div>
                              <div className="grid md:grid-cols-2 md:mb-4">
                                <div className=" grid grid-cols-2 fieldWrapper pb-2 md:mr-10 md:mb-0 mb-4">
                                  <div className="fieldName">GST</div>
                                  <div className="fieldDetails">
                                    {item?.gst ? item?.gst + "%" : "NA"}
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 fieldWrapper pb-2 md:mb-0 mb-4">
                                  <div className="fieldName">Total Price</div>
                                  <div className="fieldDetails">
                                    {item?.totalPrice ? (
                                      item?.totalPrice
                                    ) : (
                                      <>NA</>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </AccordionItemPanel>
                        </AccordionItem>
                      );
                    })
                  : null}
              </Accordion>
            </div>
          )}

          <div className="md:block flex jsutify-between items-center">
            <div className="md:title py-3.5 px-4 md:rounded-lg font-semibold text-base md:mt-4">
              <div className="flex flex-row justify-between items-center">
                <div />
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    if (formik.values.accountId) {
                      setData((prev) => [
                        ...prev,
                        {
                          productName: "",
                          productId: "",
                          productCode: "",
                          unitPrice: 0,
                          quantity: 0,
                          tempQuantity: "",
                          discount: 0.0,
                          additionalDiscount: 0.0,
                          discountPrice: 0.0,
                          gst: 0.0,
                          totalPrice: 0.0,
                        },
                      ]);

                      if (window.innerWidth > 960) {
                        dispatch({
                          type: "openDialog",
                          payload: {
                            data: {
                              handleAddName: handleAddName,
                              pdata: data,
                              index: data.length,
                              footer: true,
                              cancelBtn: true,
                              isSearch: true,
                              title: "Product Name",
                              buttonText: {
                                submit: "Save",
                              },
                              className: "!p-0",
                            },
                            path: `orders/ProductList`,
                          },
                        });
                      } else {
                        dis({
                          type: "openBottomSheet",
                          payload: {
                            data: {
                              modalType: "list",
                              handleAddName: handleAddName,
                              pdata: data,
                              index: data.length,
                              footer: true,
                              cancelBtn: true,
                              isSearch: true,
                              title: "Product Name",
                              buttonText: {
                                submit: "Save",
                              },
                              className: "!p-0",
                            },
                            path: `orders/ProductList`,
                          },
                        });
                      }
                    } else {
                      toast.error(
                        "Please select account name to add products."
                      );
                    }
                  }}
                >
                  <FiPlusSquare style={{ fontSize: 30, color: "#00A328" }} />
                </div>
              </div>
            </div>
            <div className="flex flex-row justify-end md:ms-0 m-2 md:me-2 me-4 ms-auto">
              <p className="mr-4 font-normal text-sm  gtotal">Grand Total</p>
              <p className="font-medium text-sm gtotalval">
                {numberFormat(gTotal)}
              </p>
            </div>
          </div>

          <div className="py-6 pt-0 md:px-0 px-4">
            <div>
              <FormTextarea
                label="Description"
                dom={{
                  name: "description",
                  rows: 4,
                  value: formik?.values?.description,
                  onChange: (e) =>
                    formik.setFieldValue("description", e.target.value, true),
                }}
                // required={true}
                fullwidth={true}
                error={
                  formik.touched.description &&
                  Boolean(formik.errors.description)
                }
                errorMessage={
                  formik.touched.description && formik.errors.description
                }
              />
            </div>
          </div>
          <div className="title py-3.5 px-4 md:rounded-lg font-semibold text-base">
            Address Details
          </div>
          <div className="py-6 md:px-0 px-4">
            <div className="grid md:gap-7 md:grid-cols-2">
              <div className="">
                <div>
                  <FormInput
                    label="Billing Street"
                    dom={{
                      name: "billingStreet",
                      type: "text",
                      value: formik?.values?.billingStreet,
                      readOnly: true,
                      disabled: true,
                      onChange: () => {},
                      className: " mb-3",
                    }}
                    required={true}
                    fullwidth={true}
                    error={
                      formik.touched.billingStreet &&
                      Boolean(formik.errors.billingStreet)
                    }
                    errorMessage={
                      formik.touched.billingStreet &&
                      formik.errors.billingStreet
                    }
                  />
                </div>
                <div>
                  <FormInput
                    label="Billing City"
                    dom={{
                      name: "billingCity",
                      type: "text",
                      value: formik?.values?.billingCity,
                      readOnly: true,
                      disabled: true,
                      onChange: () => {},
                      className: " mb-3",
                    }}
                    required={true}
                    fullwidth={true}
                    error={
                      formik.touched.billingCity &&
                      Boolean(formik.errors.billingCity)
                    }
                    errorMessage={
                      formik.touched.billingCity && formik.errors.billingCity
                    }
                  />
                </div>
                <div>
                  <FormInput
                    label="Billing State"
                    dom={{
                      name: "billingState",
                      type: "text",
                      value: formik?.values?.billingState,
                      readOnly: true,
                      disabled: true,
                      onChange: () => {},
                      className: " mb-3",
                    }}
                    required={true}
                    fullwidth={true}
                    error={
                      formik.touched.billingState &&
                      Boolean(formik.errors.billingState)
                    }
                    errorMessage={
                      formik.touched.billingState && formik.errors.billingState
                    }
                  />
                </div>
                <div>
                  <FormInput
                    label="Billing Postal Code"
                    dom={{
                      name: "billingPostalCode",
                      type: "text",
                      value: formik?.values?.billingPostalCode,
                      readOnly: true,
                      disabled: true,
                      onChange: () => {},
                      className: " mb-3",
                    }}
                    required={true}
                    fullwidth={true}
                    error={
                      formik.touched.billingPostalCode &&
                      Boolean(formik.errors.billingPostalCode)
                    }
                    errorMessage={
                      formik.touched.billingPostalCode &&
                      formik.errors.billingPostalCode
                    }
                  />
                </div>
                <div>
                  <FormInput
                    label="Billing Country"
                    dom={{
                      name: "billingCountry",
                      type: "text",
                      value: formik?.values?.billingCountry,
                      readOnly: true,
                      disabled: true,
                      onChange: () => {},
                      className: " mb-3",
                    }}
                    required={true}
                    fullwidth={true}
                    error={
                      formik.touched.billingCountry &&
                      Boolean(formik.errors.billingCountry)
                    }
                    errorMessage={
                      formik.touched.billingCountry &&
                      formik.errors.billingCountry
                    }
                  />
                </div>
              </div>
              <div className="">
                <div>
                  <FormInput
                    label="Shipping Street"
                    dom={{
                      name: "shippingStreet",
                      type: "text",
                      value: formik?.values?.shippingStreet,
                      className: "mb-3",
                      onChange: (e) =>
                        formik.setFieldValue(
                          "shippingStreet",
                          e.target.value,
                          true
                        ),
                    }}
                    required={true}
                    fullwidth={true}
                    error={
                      formik.touched.shippingStreet &&
                      Boolean(formik.errors.shippingStreet)
                    }
                    errorMessage={
                      formik.touched.shippingStreet &&
                      formik.errors.shippingStreet
                    }
                  />
                </div>
                <div>
                  <FormInput
                    label="Shipping City"
                    dom={{
                      name: "shippingCity",
                      type: "text",
                      className: "mb-3",
                      value: formik?.values?.shippingCity,
                      onChange: (e) =>
                        formik.setFieldValue(
                          "shippingCity",
                          e.target.value,
                          true
                        ),
                    }}
                    required={true}
                    fullwidth={true}
                    error={
                      formik.touched.shippingCity &&
                      Boolean(formik.errors.shippingCity)
                    }
                    errorMessage={
                      formik.touched.shippingCity && formik.errors.shippingCity
                    }
                  />
                </div>
                <div>
                  <FormInput
                    label="Shipping State"
                    dom={{
                      name: "shippingState",
                      type: "text",
                      className: "mb-3",
                      value: formik?.values?.shippingState,
                      onChange: (e) =>
                        formik.setFieldValue(
                          "shippingState",
                          e.target.value,
                          true
                        ),
                    }}
                    required={true}
                    fullwidth={true}
                    error={
                      formik.touched.shippingState &&
                      Boolean(formik.errors.shippingState)
                    }
                    errorMessage={
                      formik.touched.shippingState &&
                      formik.errors.shippingState
                    }
                  />
                </div>
                <div>
                  <FormInput
                    label="Shipping Postal Code"
                    dom={{
                      name: "shippingPostalCode",
                      type: "text",
                      className: "mb-3",
                      value: formik?.values?.shippingPostalCode,
                      onChange: (e) =>
                        formik.setFieldValue(
                          "shippingPostalCode",
                          e.target.value,
                          true
                        ),
                    }}
                    required={true}
                    fullwidth={true}
                    error={
                      formik.touched.shippingPostalCode &&
                      Boolean(formik.errors.shippingPostalCode)
                    }
                    errorMessage={
                      formik.touched.shippingPostalCode &&
                      formik.errors.shippingPostalCode
                    }
                  />
                </div>
                <div>
                  <FormInput
                    label="Shipping Country"
                    dom={{
                      name: "shippingCountry",
                      type: "text",
                      className: "mb-3",
                      value: formik?.values?.shippingCountry,
                      onChange: (e) =>
                        formik.setFieldValue(
                          "shippingCountry",
                          e.target.value,
                          true
                        ),
                    }}
                    required={true}
                    fullwidth={true}
                    error={
                      formik.touched.shippingCountry &&
                      Boolean(formik.errors.shippingCountry)
                    }
                    errorMessage={
                      formik.touched.shippingCountry &&
                      formik.errors.shippingCountry
                    }
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-row justify-end md:mb-0 md:mt-6 mb-3 md:px-0 px-4 md:static fixed bottom-0 right-0 left-0 bg-white-100 pt-2">
            <button
              type="button"
              className="btn btn-primary-outlined bg-white-100 mx-1.5 capitalize"
              onClick={() => navigate("/orders")}
              disabled={isLoading2}
            >
              Cancel
            </button>
            <Button
              type="submit"
              className="btn btn-primary disabled:!bg-red-900 md:w-10 !w-fit ml-1.5 capitalize"
              disabled={
                isLoading2 ||
                data?.filter((orderI, index) => {
                  return orderI?.productId;
                }).length === 0
              }
              loader={isLoading2}
            >
              Preview
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default OrderCreate;
